export default "__VITE_ASSET__NgOQnmU6__"